import React, { Component } from 'react';
import styled from 'styled-components';

import { PRIMARY_LIGHT, WHITE } from '../constants/colors';

const AccordionWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  overflow-y: auto;
  margin-bottom: 50px;
`;

const Fold = styled.div`
  background-color: ${PRIMARY_LIGHT};
`;

const FoldTrigger = styled.button`
  text-align: start;
  width: 100%;
  padding: 1rem;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  border-bottom: 1px solid ${WHITE};
  display: flex;
`;

const RotateButton = styled.img`
  ${(props) => props.isOpen && 'transform: rotateZ(90deg)'};
  transition: transform 100ms ease-out;
  width: 16px;
  margin-right: 4px;
`;

const FoldContent = styled.div`
  max-height: 0;
  overflow: hidden;
  background-color: ${WHITE};
  transition: max-height 200ms ease-in-out;
  ${(props) => props.isOpen && 'max-height: 6000px;'};
`;

export class Accordion extends Component {
  constructor(props) {
    super(props);
    this.selectFold = this.selectFold.bind(this);
    this.state = {
      active: -1,
    };
  }

  selectFold(foldNum) {
    const current = this.state.active === foldNum ? -1 : foldNum;
    this.setState(() => ({ active: current }));
  }

  render() {
    return (
      <AccordionWrap>
        {this.props.data.map((item, i) => (
          <Fold key={`${item.title}-${i}`}>
            <FoldTrigger
                onClick={() => this.selectFold(i)}
              >
              <RotateButton
                isOpen={i === this.state.active}
                alt="icon"
                src="/ic-up.svg"
              />
              {item.title}
            </FoldTrigger>
            <FoldContent isOpen={i === this.state.active}>
              {item.content}
            </FoldContent>
          </Fold>
        ))}
      </AccordionWrap>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Accordion.js